import clsx from "clsx"
import React from "react"

import { BaseLink, BaseLinkProps } from "./BaseLink"

export type OutlineLinkProps = {} & Omit<BaseLinkProps, "className">

export const OutlineLink: React.FC<OutlineLinkProps> = (props) => <BaseLink {...props} className={clsx("outline")} />
